import { render, staticRenderFns } from "./filebox.vue?vue&type=template&id=65954b80&scoped=true&"
import script from "./filebox.vue?vue&type=script&lang=js&"
export * from "./filebox.vue?vue&type=script&lang=js&"
import style0 from "./filebox.vue?vue&type=style&index=0&id=65954b80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65954b80",
  null
  
)

export default component.exports